import { MessageCircle, Sparkles, Palette, Truck, ArrowRight } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

type Paso = {
  n: number;
  icon: LucideIcon;
  title: string;
  desc: string;
};

const PASOS: Paso[] = [
  {
    n: 1,
    icon: MessageCircle,
    title: "Cotizás",
    desc: "Nos contás el tipo de negocio, la cantidad y tu logo. Te devolvemos una propuesta con precios por volumen.",
  },
  {
    n: 2,
    icon: Sparkles,
    title: "Aprobás la muestra",
    desc: "Te enviamos un preview del diseño con tu marca. Ajustamos lo que haga falta antes de producir.",
  },
  {
    n: 3,
    icon: Palette,
    title: "Producimos",
    desc: "Elaboramos cada pieza artesanalmente, con control de calidad unidad por unidad.",
  },
  {
    n: 4,
    icon: Truck,
    title: "Entregamos",
    desc: "Coordinamos la entrega en tu consultorio, oficina o evento en Panamá.",
  },
];

type ComoFuncionaProps = {
  onCotizar: () => void;
};

export const ComoFunciona = ({ onCotizar }: ComoFuncionaProps) => {
  return (
    <section className="py-20 md:py-24 bg-gradient-to-b from-background to-peach/30">
      <div className="container mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14 md:mb-16">
          <span className="text-primary-dark font-medium tracking-widest uppercase text-sm">
            Cómo funciona
          </span>
          <h2 className="font-playfair font-semibold text-3xl sm:text-4xl md:text-5xl mt-3 text-brown">
            De tu cotización a la entrega
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
        </div>

        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {PASOS.map((paso) => (
            <li
              key={paso.n}
              className="bg-background rounded-2xl border border-primary/15 p-7 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="w-8 h-8 rounded-full bg-primary text-brown-dark flex items-center justify-center font-semibold text-sm">
                  {paso.n}
                </span>
                <div className="w-10 h-10 rounded-xl bg-primary/20 flex items-center justify-center">
                  <paso.icon className="h-5 w-5 text-brown" />
                </div>
              </div>
              <h3 className="font-playfair font-semibold text-lg text-brown-dark mb-2">
                {paso.title}
              </h3>
              <p className="text-sm text-brown-light/90 leading-relaxed flex-1">
                {paso.desc}
              </p>
            </li>
          ))}
        </ol>

        <div className="text-center mt-12">
          <Button
            onClick={onCotizar}
            className="bg-primary text-brown-dark hover:bg-primary-dark font-semibold rounded-full px-8 py-3 shadow-md"
          >
            Cotizar mi pedido
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};
